import { ApiClient } from '@api/api-configuration';
import { skipGlobalErrorHandler } from '@context/api/ApiInterceptorProvider';
import type { GlobalSearchResponse } from './types';

// Called through request() (it attaches the token) until the generated client has globalSearch.
// Outside the global toast: the palette shows its own error, and aborted requests are normal.
export const globalSearch = (q: string, types: string[], signal: AbortSignal) =>
  ApiClient.clientApi
    .request<string>(
      skipGlobalErrorHandler({
        path: '/search',
        method: 'GET',
        query: { q, types, per_group: 5 },
        // Text, so the capitalize interceptor can't rewrite names ("Γιώργος" -> "γιώργος").
        format: 'text',
        secure: true,
        signal,
      })
    )
    .then((r) => JSON.parse(r.data) as GlobalSearchResponse);

export const isCanceled = (err: unknown): boolean => {
  const e = err as { name?: string; code?: string } | null;
  return e?.name === 'CanceledError' || e?.code === 'ERR_CANCELED' || e?.name === 'AbortError';
};
